import {
  Banner,
  BannerId,
  BannerName,
  Banners,
  BannerSlot,
  ImageUrl,
  IsGuestLimited,
  LinkUrl,
  SubscRetargetAttribute,
  SubscRetargetAttributes,
} from '@raysee/domain';
import { Banner as BannerSchema } from '@raysee/schema';
import { BannerRepository } from '../repository/bannerRepository';

export class BannerGateway {
  private toBanners = (firestoreBanners: BannerSchema[]): Banners =>
    new Banners(
      firestoreBanners.map(
        (banner) =>
          new Banner(
            new BannerId(banner.id),
            new BannerName(banner.name),
            new BannerSlot(banner.slot),
            new ImageUrl(banner.imageUrl),
            new LinkUrl(banner.linkUrl),
            new IsGuestLimited(banner.isGuestLimited),
            new SubscRetargetAttributes(
              banner.subscRetargetAttributes?.map(
                (retargetAttribute) => new SubscRetargetAttribute(retargetAttribute),
              ) ?? [],
            ),
          ),
      ),
    );

  private isActiveBanner = (banner: BannerSchema): boolean => {
    const now = new Date();
    const startTime = banner.startTime;
    const endTime = banner.endTime;
    // 表示終了日時 < 現在時刻 または　現在時刻 < 表示開始日時の場合は表示しない
    if (endTime && endTime < now) {
      return false;
    }
    if (startTime && now < startTime) {
      return false;
    }
    // それ以外は表示
    return true;
  };

  bannerRepository = new BannerRepository();

  getBannersForAuthUser = async (): Promise<Banners> => {
    // ゲスト限定以外のバナーを表示する
    const firestoreBanners = await this.bannerRepository.findWithoutGuestLimited('desc');
    const activeBanners = firestoreBanners.filter((banner) => this.isActiveBanner(banner));
    return this.toBanners(activeBanners);
  };

  getBannersForGuestUser = async (): Promise<Banners> => {
    // ゲストは「リタゲ絞り込み設定」のない全てのバナーを表示する
    const firestoreBanners = await this.bannerRepository.findWithoutSubscRetargetAttributes('desc');
    const activeBanners = firestoreBanners.filter((banner) => this.isActiveBanner(banner));
    return this.toBanners(activeBanners);
  };
}
